// extracted by mini-css-extract-plugin
export default {"errorPage":"styles_error-page__jz4cM","errorPage__title":"styles_error-page__title__cDSCh","errorPage__description":"styles_error-page__description__JMDTu"};